import styled from "styled-components";

interface GuideImageProps {
  /** assets/images/image_<name>.webp を背景に表示する。 */
  name: string;
}

// styled はモジュールスコープで一度だけ定義する（コンポーネント内定義は
// 再レンダリングごとにクラスが再生成され警告・再マウントの原因になるため）。
// 動的な背景画像 URL は CSS 変数経由で渡す。
const GuideImageStyle = styled.div`
  height: 160px;
  aspect-ratio: 16/9;

  border-radius: 12px;
  background-image: var(--guide-image-url);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
`;

const GuideImage: React.FC<GuideImageProps> = ({ name }) => {
  const url = new URL(
    `../../assets/images/image_${name}.webp`,
    import.meta.url,
  ).href;

  return (
    <GuideImageStyle
      style={{ "--guide-image-url": `url(${url})` } as React.CSSProperties}
    />
  );
};

export default GuideImage;
